import React, { useState } from "react";
import Cookies from "js-cookie";
import {
  DashboardContainer,
  DashboardWrapper,
  DashboardHeading,
  DashHeading,
  MenuAndBack,
  ProfileDetailForm,
  LoginButton,
} from "../Profile/ProfileElements";
import { Paper } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Formik, Field, Form } from "formik";
import InputLogin from "../../../components/InputLogin";
import axios from "../../../axios";
import Overlay from "../../../components/Overlay";
import Input from "../../../components/Input";
import { toast } from "react-toastify";
import { FaArrowLeft } from "react-icons/fa";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/actions";
import { Link, useNavigate } from "react-router-dom";
import { changedPasswordValidator } from "../../../utils/validators";
import "../Profile/profile.css";
import "./forgotPassword.css";
import { IoMdLock } from "react-icons/io";

const useStyles = makeStyles((theme) => ({
  textMiddle: {
    verticalAlign: "middle !important",
    textAlign: "center",
  },
  tablePadding: {
    padding: "0.5rem",
    textAlign: "center",
    fontSize: "0.8rem",
  },
  tablePaginationStyle: {
    border: "1px solid #0000001a",
    borderRadius: "0rem 0rem 0.4rem 0.4rem",
    overflowY: "hidden",
  },
  tableFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
  },
}));

const ChangedPassword = ({ setUsers, userData }) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const accessToken = sessionStorage.getItem("token") || localStorage.getItem("token");

  const [changedPassword, setchangedPassword] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const handleChangedPassword = async (values) => {
    setIsLoading(true);

    var fromData = {
      oldPassword: values.oldPassword,
      newPassword: values.newPassword,
      confirmPassword: values.confirmPassword,
    };

    try {
      const { data } = await axios.put(`/private/changePassword`, fromData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      localStorage.removeItem("email");
      localStorage.removeItem("token");
      localStorage.removeItem("userData");
      sessionStorage.removeItem("email");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("userData");
      Cookies.remove("showProfileSidebar");
      setUsers("");

      toast.success(`${data.message}`, {
        position: "top-right",
      });

      navigate("/");
      
    } catch (error) {
      if (error.response.status === 422) {
        toast.error(`${error.response.data?.errors[0]?.msg}`, {
          position: "top-right",
        });
      } else if (error?.response?.status === 419) {
        localStorage.removeItem("email");
        localStorage.removeItem("token");
        localStorage.removeItem("userData");
        Cookies.remove("showProfileSidebar");
        setUsers("");

        toast.error(`${error.response.data?.message}`, {
          position: "top-right",
        });

        navigate("/");
      } else {
        toast.error(error.response.data?.message, {
          position: "top-right",
        });
      }
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <DashboardContainer>
        <DashboardWrapper style={{marginTop:"1rem"}}>
          <ProfileDetailForm>
            <div className="common-heading" style={{marginBottom: "0.8rem"}}>Change Password</div>
            <span className="changed-status">Try changing your password one in a month to make your account safer.</span>

            <Formik
              enableReinitialize
              initialValues={changedPassword}
              validate={changedPasswordValidator}
              validateOnChange
              onSubmit={(values) => handleChangedPassword(values)}
            >
              {(formikBag) => {
                return (
                  <Form className="changed-password-form mt-4">
                    <div className="changed-password-container">
                      <div>
                        <label className="changed-label-name">
                          Old Password
                        </label>
                        <div className="changed-password-input justify-content-between">
                          <Field name="oldPassword">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                style={{
                                  background: formikBag.values.oldPassword ? "#FFFFFF" : "#FFFFFF",
                                }}
                                value={formikBag.values.oldPassword}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "oldPassword",
                                    e.target.value
                                  );
                                }}
                                maxLength={12}
                                className="form-control w-100"
                                placeholder="Enter old password"
                              />
                            )}
                          </Field>
                        </div>
                        <p className="error">
                          {formikBag.touched.oldPassword &&
                          formikBag.errors.oldPassword
                            ? formikBag.errors.oldPassword
                            : null}{" "}
                        </p>
                      </div>
                      <div>
                        <label className="changed-label-name">
                          New Password
                        </label>
                        <div className="changed-password-input justify-content-between">
                          <Field name="newPassword">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                style={{
                                  background: formikBag.values.newPassword ? "#FFFFFF" : "#FFFFFF",
                                }}
                                value={formikBag.values.newPassword}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "newPassword",
                                    e.target.value
                                  );
                                }}
                                className="form-control w-100"
                                maxLength={12}
                                placeholder="Enter new password"
                              />
                            )}
                          </Field>
                        </div>
                        <p className="error">
                          {formikBag.touched.newPassword &&
                          formikBag.errors.newPassword
                            ? formikBag.errors.newPassword
                            : null}
                        </p>
                      </div>
                      <div>
                        <label className="changed-label-name">
                          Confirm Password
                        </label>
                        <div className="changed-password-input justify-content-between">
                          <Field name="confirmPassword">
                            {({ field }) => (
                              <Input
                                {...field}
                                type="password"
                                style={{
                                  background: formikBag.values.confirmPassword ? "#FFFFFF" : "#FFFFFF",
                                }}
                                value={formikBag.values.confirmPassword}
                                onChange={(e) => {
                                  formikBag.setFieldValue(
                                    "confirmPassword",
                                    e.target.value
                                  );
                                }}
                                className="form-control w-100"
                                placeholder="Re-enter your password"
                                maxLength={12}
                              />
                            )}
                          </Field>
                        </div>
                        <p className="error">
                          {formikBag.touched.confirmPassword &&
                          formikBag.errors.confirmPassword
                            ? formikBag.errors.confirmPassword
                            : null}
                        </p>
                      </div>
                      <div className="mt-4 d-flex align-items-center justify-content-start">
                        <LoginButton
                          type="submit"
                          className="buttonWidthResponsive"
                        >
                          Submit
                        </LoginButton>
                      </div>
                    </div>
                  </Form>
                );
              }}
            </Formik>
          </ProfileDetailForm>
        </DashboardWrapper>
      </DashboardContainer>

      {isLoading && <Overlay />}
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    userData: state.userData,
    locationData: state.locations,
    defaultState: state.defaultState,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setUsers: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_USER,
        updatedUser: updatedValue,
      });
    },
    setDefaultState: (updatedValue) => {
      dispatch({
        type: actionTypes.UPDATE_DEFAULT,
        updateDefault: updatedValue,
      });
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangedPassword);
